import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Modal, Form, Dropdown } from 'react-bootstrap';
// utils
import { handlerErrors } from 'utils/handleErrors';
// components
import ButtonRequest from '../../../../components/buttons/ButtonRequest';
import { ToastSuccess } from '../../../../components/alerts/toast';
// API
import { editUserAccount, getSellers, getRateList } from '../../../api/Api-admin';

const EditUserModal = ({ isModalOpen, setIsModalOpen, data, setUpdatePage }) => {
  // console.log('Editar usuario -->', data);
  const [isAddChargerLoader, setIsAddChargerLoader] = useState(false);
  const [sellerCodeList, setSellerCodeList] = useState(() => {
    const stored = localStorage.getItem('sellerCodeList');
    return stored ? JSON.parse(stored) : [];
  });
  const [ratesList, setRatesList] = useState(() => {
    const stored = localStorage.getItem('ratesList');
    return stored ? JSON.parse(stored) : [];
  });

  const [dataToUpdate, setDataToUpdate] = useState({
    crm: data.crm_user_id,
    sellerCode: data.seller_code,
    customerType: data.customer_type,
    rate: data.rates_list,
    labelType: data.label_type,
    isAccountActive: data.is_active,
    isMultiPieces: data.is_multipiece_available,
    isShippingBlocked: data.blocked_shippings,
  });
  const handlerEditUser = async () => {
    try {
      setIsAddChargerLoader(true); // active loader in the button
      const response = await editUserAccount(dataToUpdate);
      // console.log('response edit:', response);
      if (response.success !== undefined) {
        setUpdatePage(true);
        ToastSuccess(response.message);
        setIsModalOpen(false);
      }
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsAddChargerLoader(false);
    }
  };
  const handlerGetSellers = async () => {
    try {
      const response = await getSellers();
      // console.log(response);
      if (response.list) {
        setSellerCodeList(response.list);
        localStorage.setItem('sellerCodeList', JSON.stringify(response.list));
      }
    } catch (error) {
      // handlerErrors(error); // da error en dashboad de vendedores
    }
  };
  const handlerGetRates = async () => {
    try {
      const response = await getRateList();
      // console.log('trarifario', response);
      if (response.rates_list) {
        setRatesList(response.rates_list);
        localStorage.setItem('ratesList', JSON.stringify(response.rates_list));
      }
    } catch (error) {
      handlerErrors(error);
    }
  };
  useEffect(() => {
    handlerGetRates();
    handlerGetSellers();
  }, []);
  //   useEffect(() => {
  //     console.log('datos para editar:', dataToUpdate);
  //   }, [dataToUpdate]);

  return (
    <Modal size="lg" show={isModalOpen} onHide={() => setIsModalOpen(false)}>
      <Modal.Header closeButton>
        <Modal.Title className="text-primary">Editar usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col lg="5" className="position-relative">
              <Form.Label>Vendedor</Form.Label>
              <Dropdown className="w-100">
                <Dropdown.Toggle variant="foreground-alternate" className="text-end shadow d-flex justify-content-between align-items-center w-100">
                  {dataToUpdate.sellerCode}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow scroll-container" align="end" style={{ fontFamily: 'Montserrat', maxHeight: '230px', overflowY: 'scroll' }}>
                  {sellerCodeList?.map((code) => (
                    <Dropdown.Item key={code} onClick={() => setDataToUpdate({ ...dataToUpdate, sellerCode: code })}>
                      {code}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col lg="4" className="position-relative">
              <Form.Label>Cliente Tipo</Form.Label>
              <Dropdown className="w-100">
                <Dropdown.Toggle variant="foreground-alternate" className="text-end shadow d-flex justify-content-between align-items-center w-100">
                  {dataToUpdate.customerType}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow dropdown-menu-start">
                  <Dropdown.Item
                    className={`${dataToUpdate.customerType === 'T' && 'd-none'}`}
                    onClick={(e) =>
                      setDataToUpdate((prevValues) => {
                        return { ...prevValues, customerType: e.target.innerText };
                      })
                    }
                  >
                    T
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`${dataToUpdate.customerType === 'C' && 'd-none'}`}
                    onClick={(e) =>
                      setDataToUpdate((prevValues) => {
                        return { ...prevValues, customerType: e.target.innerText };
                      })
                    }
                  >
                    C
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`${dataToUpdate.customerType === 'D' && 'd-none'}`}
                    onClick={(e) =>
                      setDataToUpdate((prevValues) => {
                        return { ...prevValues, customerType: e.target.innerText };
                      })
                    }
                  >
                    D
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col lg="5" className="position-relative">
              <Form.Label>Tarifario</Form.Label>
              <Dropdown className="w-100">
                <Dropdown.Toggle variant="foreground-alternate" className="text-end shadow d-flex justify-content-between align-items-center w-100">
                  {dataToUpdate.rate}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow scroll-container" align="end" style={{ fontFamily: 'Montserrat', maxHeight: '280px', overflowY: 'scroll' }}>
                  {ratesList?.map((rate) => (
                    <Dropdown.Item key={rate.ide} onClick={() => setDataToUpdate({ ...dataToUpdate, rate: rate.name })}>
                      {rate.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col lg="4" className="position-relative">
              <Form.Label>Etiqueta Tipo</Form.Label>
              <Dropdown className="w-100">
                <Dropdown.Toggle variant="foreground-alternate" className="text-end shadow d-flex justify-content-between align-items-center w-100">
                  {dataToUpdate.labelType}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow dropdown-menu-start">
                  <Dropdown.Item
                    className={`${dataToUpdate.labelType === 'COMPACT' && 'd-none'}`}
                    onClick={(e) =>
                      setDataToUpdate((prevValues) => {
                        return { ...prevValues, labelType: e.target.innerText };
                      })
                    }
                  >
                    COMPACT
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`${dataToUpdate.labelType === 'STANDARD' && 'd-none'}`}
                    onClick={(e) =>
                      setDataToUpdate((prevValues) => {
                        return { ...prevValues, labelType: e.target.innerText };
                      })
                    }
                  >
                    STANDARD
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col lg="4">
              <Form.Label>Cuenta activa</Form.Label>
              <div style={{ position: 'relative', zIndex: 1, maxWidth: '200px' }}>
                <div className="form-check ms-2">
                  <input
                    type="radio"
                    name="isAccountActive"
                    value="true"
                    className="form-check-input me-2"
                    checked={dataToUpdate.isAccountActive === true}
                    onChange={() => setDataToUpdate({ ...dataToUpdate, isAccountActive: true })}
                  />
                  <label className="form-check-label">Sí</label>
                </div>
                <div className="form-check ms-2">
                  <input
                    type="radio"
                    name="isAccountActive"
                    value="false"
                    className="form-check-input me-2"
                    checked={dataToUpdate.isAccountActive === false}
                    onChange={() => setDataToUpdate({ ...dataToUpdate, isAccountActive: false })}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </Col>
            <Col lg="4">
              <Form.Label>Multipiezas activo</Form.Label>
              <div style={{ position: 'relative', zIndex: 1, maxWidth: '200px' }}>
                <div className="form-check ms-2">
                  <input
                    type="radio"
                    name="isMultiPieces"
                    value="true"
                    className="form-check-input me-2"
                    checked={dataToUpdate.isMultiPieces === true}
                    onChange={() => setDataToUpdate({ ...dataToUpdate, isMultiPieces: true })}
                  />
                  <label className="form-check-label">Sí</label>
                </div>
                <div className="form-check ms-2">
                  <input
                    type="radio"
                    name="isMultiPieces"
                    value="false"
                    className="form-check-input me-2"
                    checked={dataToUpdate.isMultiPieces === false}
                    onChange={() => setDataToUpdate({ ...dataToUpdate, isMultiPieces: false })}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </Col>
            <Col lg="4">
              <Form.Label>Envíos bloqueados</Form.Label>
              <div style={{ position: 'relative', zIndex: 1, maxWidth: '200px' }}>
                <div className="ms-2">
                  {/* address from */}
                  <input
                    type="radio"
                    name="isShippingBlocked"
                    value="true"
                    className="form-check-input me-2"
                    checked={dataToUpdate.isShippingBlocked === true}
                    onClick={() => {
                      // setAddressErr({ ...addressErr, addressType: false });
                      setDataToUpdate({ ...dataToUpdate, isShippingBlocked: true });
                    }}
                  />
                  <label className="form-label">Si</label>
                </div>
                <div className="ms-2">
                  {/* address to */}
                  <input
                    type="radio"
                    name="isShippingBlocked"
                    value="false"
                    className="form-check-input me-2"
                    checked={dataToUpdate.isShippingBlocked === false}
                    onClick={() => {
                      // setAddressErr({ ...addressErr, addressType: false });
                      setDataToUpdate({ ...dataToUpdate, isShippingBlocked: false });
                    }}
                  />
                  <label className="form-label">No</label>
                </div>
                {/* {addressErr.addressType && <div className={`invalid-tooltip ${addressErr.addressType ? 'd-block' : 'd-none'}`}>{addressErr.addressType}</div>} */}
              </div>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => setIsModalOpen(false)} style={{ height: '36px' }} className="ms-2">
          Cancelar
        </Button>
        <ButtonRequest
          title="Editar"
          titleLoading="Editando"
          handlerFn={handlerEditUser}
          isButtonDisabled={isAddChargerLoader}
          isLoading={isAddChargerLoader}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default EditUserModal;
